/* eslint-disable @typescript-eslint/no-explicit-any */
import { mapErrors } from './map-errors';

// eslint-disable-next-line @typescript-eslint/no-empty-function
const emptyAsyncFn = async () => {};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function handleFormSubmit(options: any) {
  const { updateFn, createFn, formikActions, id, onFail } = options;
  const failHandler = onFail || emptyAsyncFn;
  let responseData;
  try {
    const apiFn = id ? updateFn : createFn;
    responseData = await apiFn();
    if (responseData.isValidationError) {
      formikActions.setErrors(mapErrors(responseData.data));
      return;
    }
    if (responseData.ok) {
      window.location.reload();
    } else {
      formikActions.setErrors({ base: `Some error occurred.` });
      await failHandler({ responseData });
    }
  } catch (e: any) {
    formikActions.setErrors({ base: `Some error occurred. ${e.message}` });
    await failHandler({ error: e, responseData });
  } finally {
    formikActions.setSubmitting(false);
  }
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export default function* handleApiFormCall() {}
